// extracted by mini-css-extract-plugin
export default {"siteloader":"siteloader_siteloader__k6SmF","main":"siteloader_main__iXOMY","center":"siteloader_center__wsomS","middle":"siteloader_middle__tHLj2","top":"siteloader_top__M+1D1"};